import React from 'react';

import PriceMatrixCell from 'shared/components/price/PriceMatrixCell';

const PriceMatrixRow = (props) => {
  const { quantity, leadTimes, matrixCell } = props;

  const MatrixCell = matrixCell || PriceMatrixCell;

  return (
    <tr>
      <td className="td-quantity">{quantity}</td>
      {leadTimes.map((leadTime, col) => (
        <MatrixCell
          key={col}
          leadTime={leadTime}
          col={col}
          {...props} />
      ))}
    </tr>
  );
};

export default PriceMatrixRow;
